import React, { useRef } from 'react'
import { motion } from 'framer-motion'
import {
  HiCurrencyDollar,
  HiCollection,
  HiOutlineClock,
  HiOutlineSearch,
  HiTrendingUp,
} from 'react-icons/hi'
import classes from './TabNavigator.module.scss'
import { HomeOverview } from '@modules/Home/Components'
import Touchable from '@components/Touchable'
import { Stack } from '@mui/material'
import { useSelectedTab, useDevMode } from '@plug-core/state'
import useWindowDimensions from '@hooks/useWindowDimensions'
import { useGoogleAnalytics } from '@plug-core/providers/GoogleAnalyticsProvider'
import { GAEventName } from '@plug-core/interfaces/googleAnalytics'
import { NftsOverview } from '@modules/Nfts/Components'
import { TransactionOverview } from '@modules/Transactions/Components'
import { DiscoverOverview } from '@modules/Discover/Components'
import { DeFiHub } from '@modules/Home/Components/DeFiHub'

const TABS = [
  { icon: HiCurrencyDollar, label: 'home', Component: HomeOverview },
  { icon: HiTrendingUp, label: 'defi', Component: DeFiHub },
  { icon: HiCollection, label: 'collections', Component: NftsOverview },
  {
    icon: HiOutlineClock,
    label: 'transactions',
    Component: TransactionOverview,
  },
  { icon: HiOutlineSearch, label: 'discover', Component: DiscoverOverview },
]

const HomeTabNavigator = () => {
  const { selectedTab, setSelectedTab } = useSelectedTab()
  const { fireEvent } = useGoogleAnalytics()
  const { devEnabled } = useDevMode()
  const { width } = useWindowDimensions()

  const { Component, label } = TABS[selectedTab]
  const isDesktop = width >= 768

  const onTabChange = (index: number) => {
    setSelectedTab(index)

    fireEvent(GAEventName.PAGE_VIEW, {
      page_title: label,
      page_location: '/home',
    })
  }

  return (
    <Stack height={`calc(100% - ${devEnabled ? 40 : 0}px)`}>
      <Stack flex={1} overflow="scroll">
        <Stack
          component={motion.div}
          key={selectedTab}
          initial={{ x: 10, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.2 }}
          flex={1}
        >
          <Component />
        </Stack>
      </Stack>
      {!isDesktop && (
        <nav className={classes.navbar}>
          <ul>
            {TABS.map(({ icon: Icon, label }, index) => {
              const selected = index === selectedTab
              return (
                <li key={label} onClick={() => onTabChange(index)}>
                  <Touchable>
                    <Icon size={25} color={selected ? 'white' : 'gray'} />
                  </Touchable>
                  {selected && (
                    <motion.div
                      className={classes.underline}
                      layoutId="underline"
                      transition={{ type: 'spring', bounce: 0.4 }}
                    />
                  )}
                </li>
              )
            })}
          </ul>
        </nav>
      )}
    </Stack>
  )
}

export default HomeTabNavigator
